import { render, staticRenderFns } from "./auditAuthOwnerList.vue?vue&type=template&id=261b8a9a&scoped=true"
import script from "./auditAuthOwnerList.vue?vue&type=script&lang=js"
export * from "./auditAuthOwnerList.vue?vue&type=script&lang=js"
import style0 from "./auditAuthOwnerList.vue?vue&type=style&index=0&id=261b8a9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261b8a9a",
  null
  
)

export default component.exports